import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { SettingsSection, SettingsSectionProps } from 'components/settings/SettingsSection';
import { useUser } from 'hooks/useUser';
import { useTranslation } from 'react-i18next';
import { SettingsField } from '../SettingsField';

export interface GeneralSettingsSectionProps extends SettingsSectionProps {}

export function GeneralSettingsSection(props: GeneralSettingsSectionProps) {
  const { t, i18n } = useTranslation();
  const { preferences, updatePreferences } = useUser();

  const supportedLanguages: string[] = Array.isArray(i18n.options.supportedLngs)
    ? i18n.options.supportedLngs
    : [];

  const handleThemeChange = (event: SelectChangeEvent) => {
    const value = event.target.value as 'light' | 'dark' | 'system';

    updatePreferences({
      themeMode: value,
    });
  };

  const handleLanguageChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    i18n.changeLanguage(value);

    updatePreferences({
      locale: value,
    });
  };

  return (
    <SettingsSection title={t('general', 'General')} {...props}>
      <SettingsField label={t('language', 'Language')}>
        <Select fullWidth value={preferences.locale} onChange={handleLanguageChange}>
          {supportedLanguages
            .filter((lang) => lang !== 'cimode')
            .map((lang) => (
              <MenuItem key={lang} value={lang}>
                {new Intl.DisplayNames(['en'], {
                  type: 'language',
                }).of(lang)}
              </MenuItem>
            ))}
        </Select>
      </SettingsField>

      <SettingsField label={t('appearance', 'Appearance')}>
        <Select fullWidth value={preferences.themeMode} onChange={handleThemeChange}>
          <MenuItem value="system">
            {t('defaultUseDeviceTheme', 'Default (use device theme)')}
          </MenuItem>
          <MenuItem value="dark">{t('darkTheme', 'Dark theme')}</MenuItem>
          <MenuItem value="light">{t('lightTheme', 'Light theme')}</MenuItem>
        </Select>
      </SettingsField>
    </SettingsSection>
  );
}
